var _style, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKyloRenLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0krl{fill:#791710;}\r\n\t.st1krl{fill:#825716;}\r\n\t.st2krl{fill:#4D4C4C;}\r\n\t.st3krl{fill:#333333;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0krl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_7"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2_1_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1krl",
    d: "M67.7,184.8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2krl",
    d: "M235.7,131c-11.6-23.7-23.3-47.5-34.9-71.2c-16.9,0.7-33.9,1.4-50.8,2c-18.8,0.7-37.5,1.5-56.3,2.2 c-10.1,22.6-20.1,45.2-30.2,67.8c-1.8,6.5-6.8,27,4.3,39.6c0.8,0.9,1.8,1.9,2.8,2.7c2.5,0.7,5,1.3,7.5,2 c6.6,12.1,13.2,21.4,18.2,27.7c11.8,15.1,22.4,28.5,40.6,34.8c5.4,1.9,10.1,2.7,13.1,3.1c2.6-0.1,6.5-0.5,11-1.6 c18.5-4.8,29.8-18.3,41.3-32.5c5.6-6.9,12.9-16.9,19.8-30.1c3.5-0.5,6.1-1.8,7.9-3C239.7,167.6,241.9,150.2,235.7,131z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M216.8,70.1c-4.3-7.6-14.8-24.1-34.4-34.7c-13-6.9-25-8.6-32.4-9c-7.4,0.4-19.4,2.1-32.4,9 C98,46,87.5,62.5,83.2,70.1c-18,31.2-35.9,62.4-53.9,93.6c0,14.9,0,29.8,0,44.7c11.9,9.4,23.9,18.8,35.9,28.2 c-1.2-13.7-2.3-27.5-3.5-41.2c11.3-26.4,22.7-52.9,34-79.3c2-5.7,6.6-16.7,16.8-26c15.3-14,32.5-14.4,37.5-14.3 c5-0.1,22.2,0.3,37.5,14.3c10.2,9.3,14.8,20.3,16.8,26c11.3,26.4,22.7,52.9,34,79.3c-1.2,13.7-2.3,27.5-3.5,41.2 c12-9.4,24-18.8,35.9-28.2c0-14.9,0-29.8,0-44.7C252.7,132.5,234.8,101.3,216.8,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M115.3,80.6c6.8,2.9,18.2,6.7,32.8,7c16,0.3,28.5-3.7,35.6-6.6c1,1.9,1.9,3.9,2.9,5.8 c-9.5,2.4-22.4,4.6-37.7,4.4c-14.2-0.2-26.3-2.3-35.4-4.7C114,84.6,114.7,82.6,115.3,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M104.9,92c9.1,3.9,24.3,9,43.8,9.4c21.3,0.5,38-5,47.5-8.8c1.3,2.6,2.6,5.2,3.9,7.8 c-12.7,3.2-29.9,6.1-50.4,5.9c-19-0.2-35.1-3.1-47.2-6.3C103.3,97.3,104.1,94.6,104.9,92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M151,123.6c0-1.1,0-2.3,0-3.4c9.9,0.8,24.7,0.7,41.6-4c9.3-2.6,16.9-6,23-9.2c0,7.6,0,15.2,0,22.8 c-2.2,2.1-8.4,7.4-18.2,8.8c-15,2.1-25.8-6.7-27.3-8c-1.8-1.4-4.5-3.2-8.1-4.6C157.5,124.2,153.6,123.7,151,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M151,123.6c0-1.1,0-2.3,0-3.4c-9.9,0.8-24.7,0.7-41.6-4c-9.3-2.6-16.9-6-23-9.2c0,7.6,0,15.2,0,22.8 c2.2,2.1,8.4,7.4,18.2,8.8c15,2.1,25.8-6.7,27.3-8c1.8-1.4,4.5-3.2,8.1-4.6C144.5,124.2,148.4,123.7,151,123.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M222.6,144.8c-5,5.5-10,11.1-15,16.6c-8.1-2-16.3-3.9-24.4-5.9c5.5,6.3,11.1,12.6,16.6,18.9 c9.1-4.3,18.2-8.7,27.3-13C225.7,155.9,224.1,150.4,222.6,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M79.4,144.8c5,5.5,10,11.1,15,16.6c8.1-2,16.3-3.9,24.4-5.9c-5.5,6.3-11.1,12.6-16.6,18.9 c-9.1-4.3-18.2-8.7-27.3-13C76.3,155.9,77.9,150.4,79.4,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M230.3,164.3c-16.4,16.4-32.8,32.8-49.2,49.2c3.2,2.8,6.4,5.5,9.6,8.3c16.3-16.7,32.6-33.4,48.9-50.2 C236.5,169.1,233.4,166.7,230.3,164.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M53.1,165.2c16.4,16.4,32.8,32.8,49.2,49.2c2.8-3.2,5.5-6.4,8.3-9.6c-16.7-16.3-33.4-32.6-50.2-48.9 C57.9,159,55.5,162.1,53.1,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3krl",
    d: "M163.4,149c-0.2-1-0.9-3.7-3.4-5.8c-4.1-3.5-9.6-1.9-10-1.8c-0.4-0.1-5.9-1.7-10,1.8 c-2.5,2.1-3.2,4.8-3.4,5.8c-12.2,20.5-24.4,41.1-36.6,61.6c2.3,3.4,4.7,6.7,7,10.1c2.2,1.6,9.4,7,12.2,17.1 c2.1,7.6,0.8,14,0,16.8c-0.5,4.1,1.3,8,4.6,10.1c3.8,2.4,7.9,1.1,8.5,0.9c5.9-1.9,11.8-3.9,17.7-5.8c5.9,1.9,11.8,3.9,17.7,5.8 c0.6,0.2,4.7,1.5,8.5-0.9c3.3-2.1,5.1-6,4.6-10.1c-0.8-2.8-2.1-9.2,0-16.8c2.8-10.1,10-15.5,12.2-17.1c2.3-3.4,4.7-6.7,7-10.1 C187.8,190.1,175.6,169.5,163.4,149z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyloRenLogo);
export default __webpack_public_path__ + "static/media/kylo-ren-logo.73e495af.svg";
export { ForwardRef as ReactComponent };